module.exports = __webpack_public_path__ + "img/MerloLogoDark.d39d51e5.png";